import { z } from 'zod';
export const EmailProviderSchema = z.enum(['IMAP', 'MICROSOFT_GRAPH', 'GMAIL']);
export const EmailAccountStatusSchema = z.enum([
    'ACTIVA',
    'ERROR_AUTH',
    'ERROR_TOKEN',
    'DESHABILITADA',
]);
export const EmailAccountStatusLabel = {
    ACTIVA: 'Activa',
    ERROR_AUTH: 'Error de autenticación',
    ERROR_TOKEN: 'Token caducado',
    DESHABILITADA: 'Deshabilitada',
};
export const CreateImapAccountSchema = z.object({
    emailAddress: z.string().email('Email no válido'),
    displayName: z.string().max(200).optional().nullable(),
    imapHost: z.string().min(2).max(255),
    imapPort: z.coerce.number().int().min(1).max(65535),
    imapUseTls: z.boolean().default(true),
    smtpHost: z.string().max(255).optional().nullable(),
    smtpPort: z.coerce.number().int().min(1).max(65535).optional().nullable(),
    smtpUseTls: z.boolean().optional().nullable(),
    password: z.string().min(1, 'La contraseña/app password es obligatoria'),
    initialSyncDays: z.coerce.number().int().min(1).max(3650).default(90),
});
export const UpdateEmailAccountSchema = z.object({
    displayName: z.string().max(200).nullable().optional(),
    syncEnabled: z.boolean().optional(),
});
export const EmailAccountDtoSchema = z.object({
    id: z.string(),
    provider: EmailProviderSchema,
    emailAddress: z.string(),
    displayName: z.string().nullable(),
    status: EmailAccountStatusSchema,
    syncEnabled: z.boolean(),
    imapHost: z.string().nullable(),
    imapPort: z.number().nullable(),
    imapUseTls: z.boolean().nullable(),
    lastSyncAt: z.string().datetime().nullable(),
    lastSyncError: z.string().nullable(),
    messagesCount: z.number().int().optional(),
    createdAt: z.string().datetime(),
});
export const EmailListQuerySchema = z.object({
    q: z.string().max(200).optional(),
    accountId: z.string().optional(),
    isRead: z.enum(['true', 'false']).optional(),
    archivedToClientId: z.string().optional(),
    archivedToCaseId: z.string().optional(),
    archived: z.enum(['true', 'false']).optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(50),
});
export const EmailListItemSchema = z.object({
    id: z.string(),
    accountId: z.string(),
    accountEmail: z.string(),
    fromAddress: z.string(),
    fromEmail: z.string(),
    subject: z.string().nullable(),
    snippet: z.string(),
    hasAttachments: z.boolean(),
    isRead: z.boolean(),
    isFlagged: z.boolean(),
    sentAt: z.string().datetime(),
    receivedAt: z.string().datetime(),
    archivedToClientId: z.string().nullable(),
    archivedToClientName: z.string().nullable(),
    archivedToCaseId: z.string().nullable(),
    archivedToCaseCode: z.string().nullable(),
});
export const EmailListResponseSchema = z.object({
    items: z.array(EmailListItemSchema),
    total: z.number().int(),
    page: z.number().int(),
    pageSize: z.number().int(),
});
export const EmailAttachmentDtoSchema = z.object({
    id: z.string(),
    fileName: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number().int(),
    inline: z.boolean(),
});
export const EmailDetailSchema = EmailListItemSchema.extend({
    toAddresses: z.array(z.string()),
    ccAddresses: z.array(z.string()),
    bccAddresses: z.array(z.string()),
    replyToAddress: z.string().nullable(),
    bodyUrl: z.string().nullable(),
    attachments: z.array(EmailAttachmentDtoSchema),
});
export const ArchiveEmailSchema = z
    .object({
    clientId: z.string().optional().nullable(),
    caseId: z.string().optional().nullable(),
})
    .refine((d) => d.clientId || d.caseId, {
    message: 'Indica al menos un cliente o causa',
});
//# sourceMappingURL=emails.js.map